import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";
import { resetApp } from "./utils/resetApp.js";
import { previewResetTestData, resetTestData } from "./utils/resetTestData.js";
import { auth } from "./firebase.js";
import { initializeAuthPersistence } from "./lib/auth.js";

// Aplicar tema oscuro ANTES de montar React para evitar flash blanco inicial
document.documentElement.classList.add('dark');

console.error('[BOOT] main.jsx START');

console.error("[BUILD_ID] 2026-02-15__A");

// Captura global de errores para debugging
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    console.error("[GLOBAL_ERROR] " + JSON.stringify({
      msg: e?.message,
      file: e?.filename,
      line: e?.lineno,
      col: e?.colno
    }));
    console.error("[GLOBAL_ERROR_STACK] " + String(e?.error?.stack || e?.error || ""));
  });

  window.addEventListener("unhandledrejection", (e) => {
    console.error("[GLOBAL_REJECTION] " + JSON.stringify({
      reason: e?.reason?.message || String(e?.reason || ""),
    }));
    console.error("[GLOBAL_REJECTION_STACK] " + String(e?.reason?.stack || ""));
  });
}

// Exponer función de reseteo globalmente para fácil acceso desde la consola
window.resetApp = resetApp;

// Fase 2 (reset seguro de datos de prueba): expuestas también por
// src/utils/resetTestData.js al importarse, se re-exponen aquí de forma
// explícita para dejar constancia del punto de entrada oficial.
window.previewResetTestData = previewResetTestData;
window.resetTestData = resetTestData;


// Inicializar Auth persistence (singleton, ejecuta una sola vez)
initializeAuthPersistence(auth).catch((err) => {
  console.error("[BOOT] Auth persistence initialization failed:", err);
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
